(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lsd-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lsd-metro-sequence-v2')) {
    customElements.define('lsd-metro-sequence-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.timers = new Set();
        this.frames = Array.from(this.querySelectorAll('.editorial-image'));
        this.pendingFrames = new Set();
        this.section = this.closest('.editorial');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const signal = this.controller.signal;
        this.motion.addEventListener('change', event => {
          if (event.matches) this.finishAll();
        }, { signal });
        this.addEventListener('shopify:block:select', () => this.finishAll(), { signal });
        this.addEventListener('focusin', () => this.finishAll(), { signal });
        window.addEventListener('beforeprint', () => this.finishAll(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden && this.arrivalActive) this.finishAll();
        }, { signal });
        if (this.motion.matches || !('IntersectionObserver' in window) || this.hasAttribute('data-critical')) return;
        try {
          this.dataset.arrivalState = this.arrivalPlayed ? 'done' : 'idle';
          this.observer = new IntersectionObserver(entries => {
            entries.filter(entry => entry.isIntersecting).forEach(entry => {
              const frame = entry.target;
              this.observer.unobserve(frame);
              if (frame.classList.contains('is-revealed')) return;
              this.pendingFrames.add(frame);
            });
            if (this.dataset.arrivalState === 'done') this.revealPending();
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
          this.arrivalObserver = new IntersectionObserver(entries => {
            if (this.dataset.arrivalState === 'idle' && entries.some(entry => entry.isIntersecting)) this.startArrival();
          }, { rootMargin: '-10% 0px -55% 0px', threshold: 0 });
          this.setAttribute('data-metro-ready', '');
          this.frames.forEach(frame => {
            if (!frame.querySelector('img') || frame.getBoundingClientRect().bottom < 0) frame.classList.add('is-revealed');
            else this.observer.observe(frame);
          });
          if (!this.arrivalPlayed && this.frames.some(frame => frame.querySelector('img'))) this.arrivalObserver.observe(this);
          window.addEventListener('scroll', () => this.checkArrivalBounds(), { passive: true, signal });
        } catch {
          this.finishAll();
        }
      }
      get arrivalActive() {
        return ['black', 'lights', 'reveal'].includes(this.dataset.arrivalState);
      }
      startArrival() {
        if (this.arrivalPlayed || this.motion.matches) return;
        this.arrivalPlayed = true;
        this.arrivalObserver?.disconnect();
        this.dataset.arrivalState = 'black';
        this.schedule(() => { this.dataset.arrivalState = 'lights'; }, 700);
        this.schedule(() => {
          this.dataset.arrivalState = 'reveal';
          this.revealPending();
        }, 2300);
        this.schedule(() => {
          this.dataset.arrivalState = 'done';
          this.revealPending();
        }, 2800);
      }
      revealPending() {
        const pending = this.frames.filter(frame => this.pendingFrames.has(frame));
        pending.forEach((frame, index) => {
          this.pendingFrames.delete(frame);
          this.schedule(() => frame.classList.add('is-revealed'), Math.min(index * 180, 720));
        });
      }
      checkArrivalBounds() {
        if (!this.arrivalActive) return;
        const bounds = this.section.getBoundingClientRect();
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lsd-header-height')) || 76;
        if (bounds.bottom <= header || bounds.top >= innerHeight - 80) this.finishAll();
      }
      finishAll() {
        this.observer?.disconnect();
        this.arrivalObserver?.disconnect();
        this.timers?.forEach(clearTimeout);
        this.timers?.clear();
        this.pendingFrames?.clear();
        this.frames?.forEach(frame => frame.classList.add('is-revealed'));
        this.arrivalPlayed = true;
        this.dataset.arrivalState = 'done';
        this.removeAttribute('data-metro-ready');
      }
      schedule(callback, delay) {
        const timer = setTimeout(() => {
          this.timers.delete(timer);
          if (this.isConnected) callback();
        }, delay);
        this.timers.add(timer);
      }
      disconnectedCallback() {
        this.finishAll();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
